var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-button"},[_c('a',{attrs:{"href":_vm.getUrl()}},[_vm._v(_vm._s(_vm.$getTextMainSetting('loginButtonText', 'Login')))])])}
var staticRenderFns = []

export { render, staticRenderFns }